<template>
    <b-container fluid v-if="advert" class="align-self-center">
        <b-row>
            <b-col cols="12" lg="6" class="p-4">
                <b-row class="p-2">
                    <b-col class="font-weight-bold text-right">Name:</b-col>
                    <b-col>{{advert.name}}</b-col>
                </b-row>
                <b-row class="p-2">
                    <b-col class="font-weight-bold text-right">Client: </b-col>
                    <b-col>{{advert.client.name}}</b-col>
                </b-row>
                <b-row class="p-2">
                    <b-col class="font-weight-bold text-right">Type: </b-col>
                    <b-col>{{advert.type.name}}</b-col>
                </b-row>
                <b-row class="p-2">
                    <b-col class="font-weight-bold text-right">Date from: </b-col>
                    <b-col>{{advert.date_from | moment("DD.MM.YYYY")}}</b-col>
                </b-row>
                <b-row class="p-2">
                    <b-col class="font-weight-bold text-right">Date to: </b-col>
                    <b-col>{{advert.date_to | moment("DD.MM.YYYY")}}</b-col>
                </b-row>
                <b-row class="p-2">
                    <b-col class="font-weight-bold text-right">Interval: </b-col>
                    <b-col v-if="advert.interval === 0 || advert.interval === 3 ">
                        ALL
                    </b-col>
                    <b-col v-else-if="advert.interval === 1">
                        DAY
                    </b-col>
                    <b-col v-else>
                        NIGHT
                    </b-col>
                </b-row>
                <b-row class="p-2">
                    <b-col class="font-weight-bold text-right">Paid: </b-col>
                    <b-col v-if="advert.paid === 1">
                        Yes
                    </b-col>
                    <b-col v-else>
                        No
                    </b-col>
                </b-row>
                <b-row class="p-2">
                    <b-col class="text-center">{{ advert.date_to | moment("from", "now")}}</b-col>
                </b-row>
                <b-row>
                    <b-col class="my-4">
                        <router-link class="w-100" :to="$route.path + '/edit'">
                            <b-btn size="lg" variant="primary" class="w-100">
                                Edit advert
                            </b-btn>
                        </router-link>
                    </b-col>
                    <b-col class="my-4">
                        <b-btn size="lg" variant="danger" class="w-100" v-b-modal.deleteAdvert>
                            Delete advert
                        </b-btn>
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="12" lg="6" class="p-4 flex-center flex-column">
                <b-embed
                        v-if="advert.type.id === 4"
                        type="video"
                        :src="advertPath + advert.file_path"
                        allowfullscreen
                        loop
                        autoplay
                ></b-embed>
                <b-img v-else
                       fluid
                       :src="advertPath + advert.file_path">
                </b-img>
            </b-col>
        </b-row>
        <b-modal centered
                 id="deleteAdvert" title="Potvrda"
                 @ok="deleteAdvert"
                 ok-variant="danger">
            <p class="my-4">Jeste li sigurni da želite izbrisati reklamu?</p>
        </b-modal>
    </b-container>
</template>

<script>
    export default {
        name: 'Advert',
        data () {
            return {
                advert: null,
            }
        },
        computed: {
          advertPath() {
              return api.advertsPath;
          }
        },
        methods: {
            deleteAdvert: function() {
                adamApi.delete(api.adverts + this.advert.id).
                then(response => {
                    this.$router.push('/adverts');
                })
            }
        },
        created () {
            adamApi.get(api.adverts + this.$route.params.id).
            then(response => {
                if (response.status === 200) {
                    this.advert = response.data;
                }
            })
        }
    }
</script>
